import type { ConversationChatStore } from "..";
import { useInitUploadFileStore } from "../uploadFile";
import { useChannelEvent } from "@/components/realtime";
import type { MessagingMessage, MessagingStatus } from "@/model/messaging";
import { useSubscribe } from "@deputy-ai/common/observable";
import { atom, useAtomValue } from "jotai";
import { useMemo } from "react";

export type MessageEventMessage = MessagingMessage & {
  taskUid: string;
};

export function useInitConversationChatStore(store?: ConversationChatStore) {
  useSubscribe(() => store?.init(), [store]);

  useInitRealtimeMessage(store);

  useInitUploadFileStore(store?.uploadFileStore);
}

function useInitRealtimeMessage(store?: ConversationChatStore) {
  const channelName = useAtomValue(
    useMemo(() => {
      return atom((get) => {
        if (!store) {
          return "";
        }
        return get(store.realtimeChannelId) ?? "";
      });
    }, [store?.realtimeChannelId])
  );

  // TODO: if realtimeChannelId is undefined, we should not subscribe to the channel
  useChannelEvent(channelName, "message", (message: MessageEventMessage) => {
    store?.handleMessageEvent(message);
  });

  useChannelEvent(
    channelName,
    "messages:status",
    (data: {
      delivered_status: Record<string, MessagingStatus>;
      message_uids: string[];
    }) => {
      store?.handleMessagesStatusEvent({
        deliveredStatus: data.delivered_status,
        messageUids: data.message_uids,
      });
    }
  );
}
